module.exports = __webpack_public_path__ + "static/media/nutrition.77efe2c3.png";